<template>
  <div class="ozon-page">
    <div v-if="isLoading">Načítavam údaje...</div>
    <div v-if="isDataLoaded">

      <h2>Stav ozónovej vrstvy nad územím Slovenska dňa: <strong>{{ ozonData.date_ts | moment('DD.MM.YYYY') }}</strong></h2>
      <p>Priemerná hodnota celkového atmosférického ozónu nameraného na stanici Poprad-Gánovce je:</p>

      <div class="text-center h3 font-bold">{{ ozonData.dobson }} Dobsonových jednotiek, čo je {{ komentar }}.</div>

      <div v-if="ozonData.comment !== null"><strong>Dodatok:</strong>
        <em> {{ ozonData.comment }}</em>
      </div>
      <div v-if="ozonData.forecast !== null"><br><strong>Predpoveď na zajtra:</strong>
        <span class="head5"> {{ ozonData.forecast.toLowerCase().trim() }}</span>
      </div>


    </div>
    <div class="clearfix"></div>
    <div class="error" v-if="isError">{{ errorMsg }}</div>
    <template v-if="!isError">
      <div class="clearfix"></div>
      <div class="position-relative">
        <h3>Celkový ozón v Poprade-Gánovciach</h3>

        <form action="?" class="position-absolute form-clear" style="right: 0; top: 0">
          <label class="fl w50 tr" for="rok">Rok:</label>
          <select class="w75 fl" v-model="selectedYear" id="rok">
            <option v-for="year in yearList" :value="year">{{ year }}</option>
          </select>
        </form>
        <div class="position-absolute" style="top:-30px; right:0" v-if="isHistoryLoading">Načítavam údaje...</div>

      </div>
      <div class="clearfix"></div>
      <template v-if="notEmptyObject(ozonHistoryData) && !isError">
        <highcharts ref="ozonHighcharts" :updateArgs="[true, true, true]" :options="chartOptions"></highcharts>
      </template>
      <div class="clearfix"></div>
      <h3 class="mb-0">Odchýlka od normálu</h3>
      <div class="clearfix"></div>
      <template v-if="notEmptyObject(ozonHistoryData) && !isError">
        <highcharts ref="ozonOdchylkaHighcharts" :updateArgs="[true, true, true]" :options="chartOdchylkaOptions"></highcharts>
      </template>
    </template>


  </div>
</template>

<script>

import SHMUconf from '../shmu_conf';
import Axios from "axios";
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';

import OzonChart from '../components/Ozon-chart-options'
import OzonOdchylkaChart from '../components/OzonOdchylka-chart-options'



Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
  },
  time: {
    timezone: 'Europe/Bratislava'
  },
  global: {
    useUTC: false
  }
});



export default {
  components: {
    highcharts: Chart,
  },
  name: 'Ozon',
  props: {
    msg: String
  },
  data() {
    return {
      ozonData: {},
      ozonHistoryData: {},
      isError: false,
      errorMsg: null,
      isDataLoaded: false,
      isHistoryDataLoaded: false,
      isLoading: false,
      isHistoryLoading: false,
      chartOptions: OzonChart,
      chartOdchylkaOptions: OzonOdchylkaChart,
      minYear: 1994,
      maxYear: null,
      selectedYear: null,
      data_dobson: [],
      data_normal: [],
      data_odchylka: [],
      tooltipEnabled: true,

    }
  },
  watch: {
    selectedYear(v) {
      this.getHistoryData();
    },
    ozonHistoryData(v) {
      this.data_dobson = [];
      this.data_normal = [];
      this.data_odchylka = [];
      v.forEach((item) => {
        this.data_dobson.push([item.dt * 1000, item.dobson]);
        this.data_normal.push([item.dt * 1000, item.normal]);
        this.data_odchylka.push([item.dt * 1000, item.odchylka]);
      })

      let m1 = this.chartOptions.series.find(item => (item.id) === 'm1');
      m1.data = this.data_dobson;
      let m2 = this.chartOptions.series.find(item => (item.id) === 'm2');
      m2.data = this.data_normal;
      let m3 = this.chartOdchylkaOptions.series.find(item => (item.id) === 'm3');
      m3.data = this.data_odchylka;
    }
  },
  mounted() {
    this.maxYear = this.$moment().format('YYYY');
    this.selectedYear = this.$moment().format('YYYY');
    this.getData();
    this.getHistoryData();

  },
  computed: {
    yearList: function() {
      let ret = [];
      for (let i = this.maxYear; i >= this.minYear; i--) {
        ret.push(i);
      }
      return ret;
    },
    komentar: function() {
      if (parseInt(this.ozonData.avg) === 0) return 'na úrovni normálu';
      else if (parseInt(this.ozonData.avg) < 0) return (0-this.ozonData.avg) + '% pod normálom';
      else return this.ozonData.avg + '% nad normálom';
    }
  },
  methods: {
    getData() {
      const self = this;

      self.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'meteo/getozoneandindexdata', {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.ozonData = response.data.ozoneData;
          self.isDataLoaded = true;
          this.isError = false;
          this.errorMsg = null;

        } else {
          this.isError = true;
          if (response.data.error[0].text) {
            this.errorMsg = response.data.error[0].text;
          } else {
            this.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }
        }
        this.isLoading = false;
      }).catch((error) => {
        this.isError = true;
        this.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        this.isLoading = false;
      });

    },
    getHistoryData() {
      const self = this;

      self.isHistoryLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'meteo/getozonyearlydata?year='+self.selectedYear, {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.isHistoryLoading = true;
          self.ozonHistoryData = response.data;
          this.isError = false;
          this.errorMsg = null;

        } else {
          this.isError = true;
          if (response.data.error[0].text) {
            this.errorMsg = response.data.error[0].text;
          } else {
            this.errorMsg = 'Nastala chyba pri načítavaní historických údajov!';
          }

        }
        this.isHistoryLoading = false;
      }).catch((error) => {
        this.isError = true;
        this.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        this.isHistoryLoading = false;
      });

    },

  }
}
</script>

<style>



</style>
